var render = function render(){var _vm=this,_c=_vm._self._c;return _c('company-profile',{attrs:{"no-redirect":"","disable-type":"","company":{type: 'INTERNAL_SUPPLIER', contactPerson: {}, phones: []}},on:{"save":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }